
export const mentions = [
  {
    key: 'Mario Rossi',
    value: 'Mario Rossi',
    text: 'Mario Rossi'
  },
  {
    key: 'Terrell L. Johnson',
    value: 'Terrell L. Johnson',
    text: 'Terrell L. Johnson'
  },
]
